import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const INotebookService = ( createDecorator('notebookService'));
export { INotebookService };
